const API_URL = 'https://api-stage.tncid.app';

export const environment = {
  production: false,
  apiUrl: API_URL,
  appTitle: 'TNC Engine',
  recaptchaSiteKey: '6LeRYg8nAAAAAIHA4fP6bQjOvpZoQk5uIYsER4YS',
  jsClientTemplate: 'tnc' as 'tnc' | 'retailor',
  TNCDataEntityId: '4c50e3d5-545a-4cf0-a47e-6b3e94ef1fa8'
};

